import Text from '@creator/ui/components/Text/Text';
import { convertFirebaseTimestampToDate, formatDate } from '@creator/ui/utils/date-utils';
import { cn } from '@creator/ui/utils/ui';
import UserDisplayNameWithLink from '@src/basic-components/UserDisplayName/UserDisplayNameWithLink';
import { useComment } from '@src/store/comments/hooks/useComment';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import type { FC } from 'react';
import { Fragment, memo } from 'react';

export interface CommentBasicInfoProps {
    className?: string;
    commentId: string;
    tokenName: string;
}

const CommentBasicInfo: FC<CommentBasicInfoProps> = props => {
    const { className = '', tokenName, commentId } = props;

    const comment = useComment(commentId);
    const createdAt = comment?.createdAt;
    const publisherName = comment?.publisherName || '';

    function getBaseClassName() {
        const { className } = props;
        const baseClassName = 'text-xs flex items-center space-x-1';
        return cn(baseClassName, className);
    }
    function getCommentCreatedTime() {
        if (!createdAt) return '';
        return formatDate(convertFirebaseTimestampToDate(createdAt));
    }

    function renderPublisher() {
        return <UserDisplayNameWithLink userDisplayNameProps={{ className: 'font-medium' }} tokenName={tokenName} profileName={publisherName} displayName={publisherName} />;
    }

    return (
        <div className={cn(getBaseClassName(), className)}>
            {renderPublisher()}
            <Text className="text-gray-500">•</Text>
            <Text className="text-gray-500">{getCommentCreatedTime()}</Text>
        </div>
    );
};

export default memo(CommentBasicInfo, propsEqualityFn);
